import React from 'react';
import CustomButton from '../../../../components/common/CustomButton';
import { HiOutlineBell, HiPlusCircle } from 'react-icons/hi';

type Props = {
  triggersCount: number;
  notificationsEnabled: boolean;
  isSlackConnected: boolean;
  onAddClick: () => void;
  onNavigateToSlack?: () => void;
  variant: 'connect' | 'empty';
};

const TriggersEmpty: React.FC<Props> = ({
  triggersCount,
  notificationsEnabled,
  isSlackConnected,
  onAddClick,
  onNavigateToSlack,
  variant
}) => {
  if (variant === 'connect') {
    return (
      <div className="py-12 text-center">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-blue-50 dark:bg-blue-900/20">
          <HiOutlineBell className="text-3xl text-blue-400 dark:text-blue-500" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white font-['Inter'] mb-2">
          Connect Slack to enable notifications
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 font-['Inter'] mb-6 max-w-md mx-auto">
          Connect your Slack workspace to start receiving automated notifications for strategy maps, work units, sprints and tasks.
        </p>
        <CustomButton
          onClick={onNavigateToSlack}
          variant="primary"
          size="md"
          className="px-6"
        >
          Connect to Slack
        </CustomButton>
      </div>
    );
  }

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-white font-['Inter']">
          {triggersCount} {Number(triggersCount) === 1 ? 'trigger' : 'triggers'} configured
        </h4>
        <CustomButton
          onClick={onAddClick}
          size="sm"
          leftIcon={<HiPlusCircle className="text-lg" />}
          disabled={!notificationsEnabled || !isSlackConnected}
        >
          Add Trigger
        </CustomButton>
      </div>
      <div className="py-12 text-center">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-blue-50 dark:bg-blue-900/20">
          <HiOutlineBell className="text-2xl text-blue-400 dark:text-blue-500" />
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-400 font-['Inter'] mb-1">
          No notification triggers configured yet.
        </p>
        <p className="text-xs text-gray-400 dark:text-gray-500 font-['Inter']">
          Click "Add Trigger" to create your first notification.
        </p>
      </div>
    </>
  );
};

export default TriggersEmpty;